<!-- 数据类型为：50500 -->
<template>
  <div :class="customEvent === 50503 ? 'five-elements-wrap' : 'firstBindingDoctor'">
    <template v-if="customEvent == 50503">
      <div
        class="header"
        :style="{
          backgroundImage: `url(${bindDoctorbg})`
        }"
      >
        <div class="title">全病程管理服务</div>
        <div class="doctor">欢迎您来到医生云工作室</div>
      </div>
      <div class="content" v-if="msg?.toDa" ref="contentRef">
        <div v-for="(mItem, mIndex) in JSON.parse(msg?.toDa)" :key="mIndex" class="item">
          <span v-html="handleHTML(mItem)"></span>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- 新数据 -->
      <div v-if="props?.msg?.msgList?.length > 0">
        <div v-for="(mItem, mIndex) in JSON.parse(props?.msg?.msgList)" :key="mIndex" class="item">
          <span>{{ mIndex + 1 }}.{{ mItem.text }}</span>
          <span>
            <span v-if="mItem && mItem.subText === 'phone'">{{ props?.msg?.phoneNumber }}。</span>
            <span
              v-if="mItem && mItem.subText === 'step'"
              style="color: #4c6ee0; cursor: pointer"
              @click="selImage = true"
            >
              查看操作步骤>>
            </span>
          </span>
        </div>
      </div>
      <div v-else>
        <!-- 旧数据 -->
        <div v-html="props?.msg?.msg"></div>
        <div>医助热线：{{ props?.msg?.phoneNumber }}</div>
      </div>
    </template>
    <!-- 预览操作步骤 -->
    <a-modal
      v-model:visible="selImage"
      title="查看操作步骤"
      wrapClassName="full-modal"
      width="700px"
      :footer="null"
    >
      <auth-img
        mode="ant"
        :src="customEvent == 50503 ? operationSteps : stepsImage"
        :preview="false"
      ></auth-img>
    </a-modal>
  </div>
</template>
<script setup>
import stepsImage from '@/assets/img/chat/steps.png'
import bindDoctorbg from '@/assets/img/chat/bindDoctorbg.png'
import operationSteps from '@/assets/img/chat/operationSteps.png'
import { defineProps, onMounted, onUnmounted, ref } from 'vue'
const props = defineProps({
  msg: {
    type: Object,
    default: () => {}
  },
  customEvent: {
    type: Number,
    default: 50500
  },
  doctorName: {
    type: String,
    default: ''
  }
})

const selImage = ref(false)
const contentRef = ref(null)
const handleHTML = item => {
  const { text, subText, clickType } = item
  if (clickType === 'operationSteps') {
    const regExp = new RegExp(subText, 'g')
    return text.replace(
      regExp,
      `<span style="color: #3F64FF; cursor: pointer; text-decoration-line:underline" data-action="handleSteps" >${subText}</span>`
    )
  } else {
    return item.text
  }
}
const handleSteps = () => {
  selImage.value = true
}
onMounted(() => {
  if (contentRef.value) {
    contentRef.value.addEventListener('click', event => {
      if (event.target.dataset.action === 'handleSteps') {
        handleSteps()
      }
    })
  }
})
onUnmounted(() => {
  if (contentRef.value) {
    contentRef.value.removeEventListener('click', event => {
      if (event.target.dataset.action === 'handleSteps') {
        handleSteps()
      }
    })
  }
})
</script>
<style scoped lang="scss">
.firstBindingDoctor {
  background: #e8e8e9;
  padding: 12px 16px;
  list-style: none;
  text-align: left;
  display: inline-block;
  word-break: break-all;
  margin: 0;
  font-size: 14px;
  color: #333333;
  border-radius: 2px 8px 8px 8px;
  overflow: hidden;

  .item {
    margin-bottom: 12px;
  }
  .item:last-child {
    margin-bottom: 0;
  }
}
.five-elements-wrap {
  width: 267px;
  background-image: linear-gradient(180deg, #5075f0 1%, #6ab2ff 100%);
  border-radius: 0px 8px 8px 8px;
  overflow: hidden;
  letter-spacing: 0;
  .header {
    padding: 12px 12px 10px;
    color: #ffffff;
    background-repeat: no-repeat;
    background-size: 156px;
    background-position: top right;
    .title {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
    }
    .doctor {
      font-weight: 400;
      font-size: 12px;
      text-align: justify;
      line-height: 16px;
      margin-top: 6px;
    }
  }
  .content {
    background: #ffffff;
    border-radius: 6px;
    overflow: hidden;
    margin: 0 4px 4px;
    padding: 10px;
    .item {
      color: #333333;
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      margin-bottom: 4px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
